import { render, staticRenderFns } from "./CriterionSummary.vue?vue&type=template&id=082be66c&lang=pug"
import script from "./CriterionSummary.vue?vue&type=script&lang=js"
export * from "./CriterionSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports